import type { DashboardStat } from '@data/useDashboardStats';
import { Axis, BarSeries, Chart, Settings, LIGHT_THEME } from '@elastic/charts';
import '@elastic/charts/dist/theme_light.css';

export default function RegistrationGraph({
  stats,
}: {
  stats: DashboardStat[];
}) {
  const data = [
    ...stats.map(({ typeName, registeredVoters }) => ({
      typeName,
      count: registeredVoters,
      category: 'Registered on time',
    })),
    ...stats.map(({ typeName, registeredLate }) => ({
      typeName,
      count: registeredLate,
      category: 'Registered late',
    })),
    ...stats.map(({ typeName, total, registeredVoters, registeredLate }) => ({
      typeName,
      count: total - registeredVoters - registeredLate,
      category: 'Not registered',
    })),
  ];

  return (
    <Chart size={{ height: 300 }}>
      <Settings
        baseTheme={LIGHT_THEME}
        rotation={90}
        showLegend={true}
        legendPosition="right"
      />
      <BarSeries
        id="registration"
        name="Registration"
        data={data}
        xAccessor="typeName"
        yAccessors={['count']}
        splitSeriesAccessors={['category']}
        stackAccessors={['category']}
      />
      <Axis id="bottom-axis" position={'left'} gridLine={{ visible: false }} />
      <Axis id="left-axis" position={'bottom'} />
    </Chart>
  );
}
